import { Endpoints } from '@/ts/store/Constants';

const BLACKLISTED_ENDPOINTS = {
    dynamicRoutes: [
        Endpoints.Admin.EventLogs.EVENT_LOGS_UNSEEN,
        Endpoints.Admin.EventLogs.MAKE_EVENT_LOG_SEEN,
        Endpoints.Admin.Conversations.CHECK_PROPERTY_CONVERSATION,
        Endpoints.Admin.Conversations.SUGGESTED_STUFF_USERS,
        Endpoints.Versions.AVAILABLE_UPDATE_URL,
        Endpoints.Localization.LOCALIZATION_DATA,
        Endpoints.Documents.MARK_ACTIVE_DOCUMENT_AS_SEEN,
        Endpoints.Conversations.CONVERSATION_UPDATES,
        Endpoints.Conversations.MARK_CONVERSATION_AS_SEEN,
        Endpoints.Notifications.MARK_ACTIVE_NOTIFICATION_AS_SEEN,
        Endpoints.Channels.CHANNEL_MESSAGES,
    ],
    staticRoutes: [
        Endpoints.Admin.EventLogs.EVENT_LOGS_UNSEEN_COUNT,
        Endpoints.Admin.EventLogs.MARK_ALL_EVENT_LOGS_AS_SEEN,
        Endpoints.Users.FIREBASE_TOKEN,
        Endpoints.Users.TRACK_ACTION,
        Endpoints.Users.PROFILE_IMAGE,
        Endpoints.Tickets.USER_INQUIRY_TYPES,
        Endpoints.Tickets.USER_INQUIRY_QUESTIONS,
        Endpoints.Tickets.USER_INQUIRY_CATEGORIES,
        Endpoints.Tickets.TICKET_MESSAGE_TO_ADMIN,
        Endpoints.Versions.LAST_VERSION,
        Endpoints.Notifications.NOTIFICATIONS_UNREAD_COUNT,
    ],
};

const LOADING_BAR_ENDPOINTS = {
    dynamicRoutes: [
        Endpoints.Admin.Projects.GET_BUILDING_MANAGER_SUGGESTIONS,
        Endpoints.Admin.Buildings.PROPERTY_MANAGER_SUGGESTIONS,
        Endpoints.Admin.Variants.VARIANT_MEDIA,
        Endpoints.Admin.Variants.VARIANT_MEDIA_PREVIEW,
        Endpoints.Admin.Properties.TENANCY_PERIODS,
        Endpoints.Admin.Properties.TENANCY_PERIOD_ACTIVITY,
        Endpoints.Admin.Properties.PROPERTY_FLOOR_PLAN,
        Endpoints.Admin.Properties.PROPERTY_NOTES,
        Endpoints.Admin.Properties.PROPERTY_NOTE_MEDIA,
        Endpoints.Admin.PropertyGroupings.GROUPINGS_TENANTS,
        Endpoints.Admin.PropertyGroupings.GROUPING_RESIDENTS,
        Endpoints.Admin.Documents.DOCUMENTS,
        Endpoints.Admin.Documents.PREVIEW_MEDIA,
        Endpoints.Admin.Staff.SINGLE_STAFF,
        Endpoints.Admin.Notifications.NOTIFICATION_MEDIA,
        Endpoints.Admin.Events.EVENT_MEDIA,
        Endpoints.Admin.EventLogs.EVENT_LOGS,
        Endpoints.Admin.SharedFacilities.PROJECT_ALL_FACILITIES,
        Endpoints.Admin.SharedFacilities.ACTIVE_ADMIN_FACILITY_PHOTOS,
        Endpoints.Admin.SharedFacilities.ACTIVE_ADMIN_FACILITY_BOOKINGS,
        Endpoints.Admin.SharedFacilities.FACILITY_PHOTOS_ORDER,
        Endpoints.Admin.TicketsAttributes.TICKET_ALL_CATEGORIES,
        Endpoints.Admin.TicketsAttributes.TICKET_INQUIRIES,
        Endpoints.Admin.TicketsAttributes.INQUIRY_ROLE_ASSIGNEE_USERS,
        Endpoints.Admin.TicketsAttributes.UPDATE_INQUIRY_SORT,
        Endpoints.Admin.TicketsAttributes.UPDATE_INQUIRY_CATEGORY_SORT,
        Endpoints.Admin.TicketSystem.TICKETS,
        Endpoints.Admin.TicketSystem.TICKET_SUGGESTED_WATCHERS,
        Endpoints.Admin.TicketSystem.FETCH_TICKET_CONVERSATION,
        Endpoints.Admin.Integration.CORPORATION_INTEGRATIONS,
        Endpoints.Admin.WaitingList.WAITING_LISTS,
        Endpoints.Admin.PresentationFlow.ALL_VACANT_UNITS,
        Endpoints.Admin.PresentationFlow.ALL_IN_PROGRESS_OFFERS,
        Endpoints.Admin.PresentationFlow.ALL_DEADLINE_OFFERS,
        Endpoints.Admin.PresentationFlow.ALL_SENT_OFFERS,
        Endpoints.Admin.PresentationFlow.ALL_COMPLETED_OFFERS,
        Endpoints.Admin.PresentationFlow.CURRENT_VACANT_UNIT,
        Endpoints.Admin.PresentationFlow.APPLICATIONS_FOR_PRESENTATION,
        Endpoints.Admin.PresentationFlow.CURRENT_EDIT_PRESENTATION,
        Endpoints.Admin.ConversationConvert.CONVERT_TICKET_ALL_CATEGORIES,
        Endpoints.Admin.ConversationConvert.CONVERT_TICKET_ALL_ASSIGNEE,
        Endpoints.Admin.Conversations.CHANGE_CONVERSATION_TITLE,
        Endpoints.Admin.Conversations.ADD_DIRECT_CONVERSATION,
        Endpoints.Admin.Conversations.CHANGE_CONVERSATION_STATUS,
        Endpoints.Admin.Localization.LANGUAGE_TEXTS,
        Endpoints.Admin.Localization.GLOBAL_CHANGE_LANGUAGE,
        Endpoints.Admin.TextEditor.STORE_TEXT_EDITOR_IMAGE,
        Endpoints.Users.MINIATURE,
        Endpoints.Users.USER_PROFILE_IMAGE,
        Endpoints.Tickets.ALL_USER_TICKETS,
        Endpoints.Tickets.USER_CURRENT_TICKET_TYPE,
        Endpoints.Tickets.USER_CURRENT_TICKET_CATEGORY,
        Endpoints.Tickets.USER_CURRENT_TICKET_INQUIRY,
        Endpoints.Tickets.USER_TICKET_ALL_CATEGORIES,
        Endpoints.Tickets.USER_TICKET_ALL_INQUIRIES,
        Endpoints.Tickets.USER_TICKET_CONVERSATION,
        Endpoints.Tickets.TICKET_IMAGES,
        Endpoints.Options.OPTION_IMAGE_ORIGINAL,
        Endpoints.Options.OPTION_IMAGE_THUMBNAIL,
        Endpoints.Options.OPTION_IMAGE_LARGE,
        Endpoints.Documents.DOCUMENTS_LIST,
        Endpoints.Documents.DOCUMENT_PREVIEW,
        Endpoints.Documents.ACTIVE_DOCUMENT,
        Endpoints.Conversations.MESSAGE_PHOTO,
        Endpoints.Conversations.MESSAGE_LIST,
        Endpoints.Booking.SHARED_FACILITY_PHOTOS,
        Endpoints.Booking.FACILITY_UNAVAILABILITY,
        Endpoints.Notifications.DASHBOARD_NOTIFICATIONS,
        Endpoints.Notifications.SHOW_TENANT_NOTIFICATION,
        Endpoints.Notifications.TENANT_NOTIFICATIONS_LOGS,
        Endpoints.Notifications.USER_NOTIFICATION_MEDIA,
        Endpoints.Notifications.POST_USER_ATTENDING_CALENDAR_EVENT,
        Endpoints.Images.IMAGE_ORIGINAL,
        Endpoints.Images.IMAGE_LARGE,
        Endpoints.Images.IMAGE_THUMBNAIL,
        Endpoints.Tags.FETCH_TAGS,
    ],
    staticRoutes: [
        Endpoints.Admin.Roles.STAFF_ROLES,
        Endpoints.Admin.Roles.PERMISSION_ROLES,
        Endpoints.Admin.Roles.PERMISSION_FEATURES,
        Endpoints.Admin.Staff.STAFF,
        Endpoints.Admin.Documents.FETCH_DOCUMENT_CATEGORIES,
        Endpoints.Admin.Corporations.CORPORATIONS_LIST,
        Endpoints.Admin.Projects.PROJECTS,
        Endpoints.Admin.Buildings.BUILDINGS,
        Endpoints.Admin.Variants.VARIANTS,
        Endpoints.Admin.PropertyGroupings.GROUPING_TYPES,
        Endpoints.Admin.Notifications.NOTIFICATIONS,
        Endpoints.Admin.Events.EVENTS,
        Endpoints.Admin.SharedFacilities.ALL_FACILITY_TYPES,
        Endpoints.Admin.TicketsAttributes.TICKET_ALL_TYPES,
        Endpoints.Admin.TicketsAttributes.INQUIRY_ROLE_ASSIGNEE,
        Endpoints.Admin.TicketsAttributes.UPDATE_INQUIRY_TYPE_SORT,
        Endpoints.Admin.TicketSystem.TICKET_ALL_STATES,
        Endpoints.Admin.ConversationConvert.CONVERT_TICKET_ALL_TYPES,
        Endpoints.Admin.ConversationConvert.CONVERT_TICKET_ALL_STATES,
        Endpoints.Admin.ConversationConvert.CONVERT_TICKET_ALL_WATCHERS,
        Endpoints.Admin.Countries.COUNTRY,
        Endpoints.Admin.Tags.SOCIAL_TAG,
        Endpoints.Admin.Localization.ALL_LANGUAGES,

        Endpoints.Users.FEEDBACK_EVENTS,
        Endpoints.Tickets.USER_ADD_NEW_TICKET,
        Endpoints.Roles.USER_ROLES,
        Endpoints.Suggestions.USER_SUGGESTIONS,
        Endpoints.Suggestions.ASSOCIATED_USERS_LIST,
        Endpoints.Likes.USER_ADD_LIKE,
        Endpoints.Options.OPTION,
        Endpoints.Options.OPTION_IMAGE_POST,
        Endpoints.Booking.USER_FACILITIES_BOOKINGS,
        Endpoints.Booking.USER_SHARED_FACILITIES,
        Endpoints.Conversations.CONVERSATION_LIST,
        Endpoints.Notifications.NOTIFICATIONS_LIST,
        Endpoints.Notifications.EVENTS_LIST,
        Endpoints.Notifications.TENANT_UPCOMING_EVENTS,
        Endpoints.Properties.STAFF_PROPERTIES,
        Endpoints.Attachments.ATTACHMENT,
    ],
};

export default class Loading {
    protected readonly blacklistPattern: string;
    protected readonly loadingPattern: string;

    constructor() {
        this.blacklistPattern = this.dynamicEndpointsPattern('blacklist');
        this.loadingPattern = this.dynamicEndpointsPattern('loading');
    }

    public checkIfRouteIsBlacklisted(url: string): boolean {
        if (BLACKLISTED_ENDPOINTS.staticRoutes.includes(url)) {
            return true;
        }

        return new RegExp(this.blacklistPattern).test(url);
    }

    public checkIfRequireLoadingBar(url: string): boolean {
        if (url.includes('?')) {
            url = url.substring(0, url.indexOf('?'));
        }

        if (LOADING_BAR_ENDPOINTS.staticRoutes.includes(url)) {
            return true;
        }

        return new RegExp(this.loadingPattern).test(url);
    }

    protected dynamicEndpointsPattern(type: string): string {
        let fullRegexPattern = '^(?:';

        let endpointsArray: any;
        let iterations: number;

        if (type === 'loading') {
            endpointsArray = LOADING_BAR_ENDPOINTS.dynamicRoutes;
            iterations = LOADING_BAR_ENDPOINTS.dynamicRoutes.length;
        } else {
            endpointsArray = BLACKLISTED_ENDPOINTS.dynamicRoutes;
            iterations = BLACKLISTED_ENDPOINTS.dynamicRoutes.length;
        }

        for (const endpoint of endpointsArray) {
            // @ts-ignore
            fullRegexPattern += typeof endpoint === 'function' ? endpoint().replace(/undefined/gm, '(.*)').replace(/\?/gm, '\\?') : endpoint;

            if (--iterations) {
                fullRegexPattern += '|';
            }
        }

        fullRegexPattern += ')$';

        return fullRegexPattern;
    }
}
